<template>
  <n-popover
    v-model:show="isShowContent"
    trigger="click"
    :show-arrow="false"
    placement="bottom-start"
    v-bind="$attrs"
    @clickoutside="handleClickOutside"
  >
    <template #trigger>
      <nd-button class="whitespace-nowrap" :class="{ active: triggerActive }" size="medium" type="secondary" :icon="props.triggerIcon">
        {{ props.triggerLabel }}
      </nd-button>
    </template>

    <template #default>
      <div class="filter-popup py-2 bg-white rounded">
        <div class="content relative">
          <slot :visible="isShowContent" :onValidation="handleContentValidation">popup content</slot>
        </div>
        <div class="actions flex justify-end items-center py-6 px-5 gap-2">
          <nd-button v-if="props.showClear" type="text" @click="handleFilterClear">{{ $t('all_clear') }}</nd-button>
          <nd-button type="primary" :loading="isLoading" :disabled="!isSubmittable" @click="handleSubmit">
            {{ $t('filter_result_and_action_button', { result: props.productCount }) }}
          </nd-button>
        </div>
      </div>
    </template>
  </n-popover>
</template>

<script setup lang="ts">
import { NPopover } from 'naive-ui'

const props = withDefaults(
  defineProps<{
    productCount: number
    triggerLabel: string
    triggerIcon: string
    triggerActive: boolean
    showClear: boolean
    isLoading?: boolean
  }>(),
  {
    productCount: 0,
    triggerLabel: '',
    triggerIcon: '',
    triggerActive: false,
    showClear: false,
    isLoading: false,
  }
)

const emit = defineEmits<{
  (event: 'clear'): void
  (event: 'submit'): void
  (event: 'close'): void
}>()

const isShowContent = ref(false)
const isContentValid = ref(true)
const isSubmittable = computed(() => isContentValid.value)

const triggerActive = computed(() => isShowContent.value || props.triggerActive)

const handleFilterClear = () => emit('clear')

const handleSubmit = () => {
  isShowContent.value = false
  emit('submit')
}

const handleClickOutside = () => {
  emit('close')
}

const handleContentValidation = (result: boolean) => {
  isContentValid.value = result
}
</script>

<style lang="scss" scoped></style>
